import { render, staticRenderFns } from "./permissionView.vue?vue&type=template&id=37d10c22&scoped=true"
import script from "./permissionView.vue?vue&type=script&lang=js"
export * from "./permissionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d10c22",
  null
  
)

export default component.exports